"use strict";

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var CNAddressLabel = /** @class */function (_super) {
    __extends(CNAddressLabel, _super);
    function CNAddressLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    CNAddressLabel.prototype.handleClick = function () {
        this.props.onClick && this.props.onClick(this.props.node);
    };
    CNAddressLabel.prototype.render = function () {
        return React.createElement("button", { className: classNames("next-cn-address-label", { checked: this.props.checked }), onClick: this.handleClick }, this.props.node.nameZh);
    };
    CNAddressLabel.propTypes = {
        node: PropTypes.object,
        checked: PropTypes.bool,
        onClick: PropTypes.func
    };
    return CNAddressLabel;
}(React.Component);
exports.default = CNAddressLabel;
//# sourceMappingURL=CNAddressLabel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddressLabel.js
// module id = 531
// module chunks = 0